import { ChangeDetectionStrategy, Component, forwardRef, input, output, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputSize } from '../../../enum/input-size.enum';
import { MatIcon } from '@angular/material/icon';
import { TooltipDirective } from '../../../../directives/tooltip.directive';

@Component({
  selector: 'lib-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, TooltipDirective],
})
export class TextInputComponent implements ControlValueAccessor {
  placeholder = input<string>('');
  controlId = input<string | null>(null);
  error = input<boolean>(false);
  inputSize = input<InputSize>(InputSize.large);
  showClearButton = input<boolean | null | undefined>();
  type = input<'text' | 'number'>('text');
  inputMode = input<'text' | 'numeric' | 'decimal' | 'tel' | 'search' | 'email' | 'url'>('text');
  autocomplete = input<string>('on');
  helpText = input<string>();
  valueChange = output<string | null>();

  protected readonly InputSize = InputSize;

  public value = signal<string | null>(null);
  public disabled = signal(false);

  public writeValue(value: string | null): void {
    this.value.set(value);
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value.set(inputValue);
    this.valueChange.emit(inputValue);
    this.onChange(inputValue);
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  public clearClicked(): void {
    this.value.set(null);
    this.valueChange.emit(null);
    this.onChange(null);
  }

  private onChange: (value: string | null) => void = () => {
    // default onChange
  };
  private onTouched: () => void = () => {
    // default onTouched
  };
}
